import * as angular from "angular";
import {IController, IWindowService} from "angular";
import {TextTemplatePurposeType} from "../../../text-templates/types/text-template-purpose.type";
import {TextTriggerType} from "../../types/text-trigger.type";
import * as _ from "lodash";
import {TextTriggerGroupType} from "../../types/text-trigger-group.type";
import {OrderAttachmentFileType} from "../../../attachments/types/orderAttachmentFile.type";
import {SplitService} from "../../../commons/services/split-service.service";

export class NotificationConfigurationFormComponent implements IController {

  notification: any;
  selectedNavLanguage: string;
  cancellationTags: any;
  fileTypes: any;
  siteTags: any;
  sitePrograms: any;
  onReset: Function;
  onSave: Function;

  public textTemplatePurposeType: typeof TextTemplatePurposeType = TextTemplatePurposeType;
  public textTriggerGroupType: typeof TextTriggerGroupType = TextTriggerGroupType;
  public textTriggerType: typeof TextTriggerType = TextTriggerType;
  public shouldAddFileToEmail: { enabled: boolean };
  public isResetDisabled: boolean;
  public languages: any;
  public cancellationReasons: any;
  public expandSectionMap: any = {};
  public siteOperationalContactTypes: string[];

  constructor(private $window: IWindowService, private splitService: SplitService,
              private UUIDService) {
    this.siteOperationalContactTypes = splitService.getOperationalContactTypes();
  }

  $onInit() {
    this.expandSectionMap[0] = true;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.notification && !changes.notification.isFirstChange()) {
      if (!!this.notification) {

        this.languages = Object.keys(this.notification.messages);

        this.shouldAddFileToEmail = {enabled: undefined}

        switch (this.notification.textTriggerGroup) {
          case TextTriggerGroupType.FulfillmentLine: {
            this.fileTypes = Object.values(OrderAttachmentFileType);
            this.shouldAddFileToEmail.enabled = !!_.get(this.notification, 'orderAttachmentFileTypes.length');
            break;
          }
        }

        this.isResetDisabled = this.notification.type !== 'Edited';

        if (this.notification.trigger === this.textTriggerType.REMINDER_SMS_MINUTES_AFTER) {
          if (!this.notification.scheduleMessageSetting) {
            this.notification.scheduleMessageSetting = {};
          }
        }

      }
    }

    if (changes.cancellationTags && !!this.cancellationTags?.length) {
      this.cancellationReasons = this.cancellationTags.map(ct => ct.reason);
    }
  }

  onToggleSection(index) {
    this.expandSectionMap[index] = !this.expandSectionMap[index]
  }

  onSelectLanguage(languageKey) {
    this.selectedNavLanguage = languageKey;
  }

  onAddTagItem(tagItem, notificationRef, focusElementId) {
    notificationRef.messages[this.selectedNavLanguage] += ' {' + tagItem.key + '}';

    if (focusElementId) {
      const element = this.$window.document.getElementById(focusElementId);
      if (element) {
        element.focus();
      }
    }
  }

  onAddSpecialTag() {
    if (!this.notification.specialTagMap) {
      this.notification.specialTagMap = {};
    }

    if (this.siteTags.length) {

      const tagToAdd = _.find(this.siteTags, (t) => {
        return !this.notification.specialTagMap[t.name];
      })
      const tagName = _.get(tagToAdd, 'name');

      if (tagName) {
        const notificationPayload = angular.copy(this.notification);
        _.unset(notificationPayload.specialTagMap[tagName], 'specialTagMap')

        this.notification.specialTagMap[tagName] = notificationPayload;
      }

    }
  }

  onAddByProgramType() {
    if (!this.notification.specialProgramMap) {
      this.notification.specialProgramMap = {};
    }

    if (this.sitePrograms.length) {

      const programToAdd = _.find(this.sitePrograms, (p) => {
        return !this.notification.specialProgramMap[p.id];
      });

      if (programToAdd) {
        this.notification.specialProgramMap[programToAdd.id] = angular.copy(this.notification);
      }
    }
  }

  onAddByOperationContacts() {
    if (!this.notification.operationContactVersionTemplates) {
      this.notification.operationContactVersionTemplates = [];
    }

    if (this.siteOperationalContactTypes.length) {
      let operationalContactVersionTemplate = {
        template: angular.copy(this.notification),
        subTemplateVersionId: this.UUIDService.generate(),
        considerTemplateVersionId: this.notification.trigger ===
            TextTriggerType.REMINDER_SMS_MINUTES_AFTER_OPERATIONAL_CONTACTS
            || this.notification.trigger === TextTriggerType.REMINDER_SMS_DAY_BEFORE_OPERATIONAL_CONTACTS
      }


      this.notification.operationContactVersionTemplates.push(operationalContactVersionTemplate)
    }
  }

  onAddVersion() {
    if (!this.notification.subTemplates) {
      this.notification.subTemplates = [];
    }

    const version = angular.copy(this.notification);
    if (!version.scheduleMessageSetting) {
      version.scheduleMessageSetting = {};
    }
    this.notification.subTemplates.push(version);
  }

  onAddCancellationReason() {

    if (!this.notification.cancellationReasons) {
      this.notification.cancellationReasons = {};
    }

    if (this.cancellationTags.length) {

      const cancellationReasonToAdd = _.find(this.cancellationTags, (ct) => {
        return !this.notification.cancellationReasons[ct.reason];
      })
      const cancellationReasonName = _.get(cancellationReasonToAdd, 'reason');

      if (cancellationReasonName) {
        const notificationPayload = angular.copy(this.notification);
        _.unset(notificationPayload.cancellationReasons[cancellationReasonName], 'cancellationReasons');

        this.notification.cancellationReasons[cancellationReasonName] = notificationPayload;
      }

    }
  }

  hasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
  }

  onSpecialTagChange(tagName, updatedTagName) {
    if (tagName === updatedTagName) {
      return;
    }
    _.set(this.notification.specialTagMap, updatedTagName, angular.copy(this.notification.specialTagMap[tagName]));
    this.onRemoveSpecialTag(tagName);
  }

  onSpecialProgramChange(programId, updatedProgramId) {
    if (programId === updatedProgramId) {
      return;
    }
    _.set(this.notification.specialProgramMap, updatedProgramId, angular.copy(this.notification.specialProgramMap[programId]));
    this.onRemoveSpecialProgram(programId);
  }

  onSpecialOperationalContactsChange(updatedOperationalContactTypes, notification) {
    if (!notification || !updatedOperationalContactTypes) {
      return;
    }

    notification.contactTypes = updatedOperationalContactTypes;
  }

  onRemoveSpecialProgram(programId) {
    _.unset(this.notification.specialProgramMap, programId);
    if (_.isEmpty(this.notification.specialProgramMap)) {
      this.notification.specialProgramMap = undefined;
    }
  }

  onRemoveSpecialOperationalContact(index) {
    this.notification.operationContactVersionTemplates.splice(index, 1);

    if (!this.notification.operationContactVersionTemplates.length) {
      this.notification.operationContactVersionTemplates = undefined;
    }
  }

  onRemoveVersion(index) {
    this.notification.subTemplates.splice(index, 1);

    if (!this.notification.subTemplates.length) {
      this.notification.subTemplates = undefined;
    }
  }


  onRemoveSpecialTag(tagName) {
    _.unset(this.notification.specialTagMap, tagName);
    if (_.isEmpty(this.notification.specialTagMap)) {
      this.notification.specialTagMap = undefined;
      this.notification.sendOnlySpecialTagMessages = false;
    }
  }

  onCancellationReasonChange(newCancellationReasonKey, originalCancellationReasonKey) {
    _.set(this.notification.cancellationReasons, newCancellationReasonKey, angular.copy(this.notification.cancellationReasons[originalCancellationReasonKey]));
    this.onRemoveCancellationReason(originalCancellationReasonKey);
  }

  onRemoveCancellationReason(cancellationReasonName) {
    _.unset(this.notification.cancellationReasons, cancellationReasonName);
  }

  onToggleAttachedFileTypes(shouldAddFileToEmail) {
    switch (this.notification.textTriggerGroup) {
      case TextTriggerGroupType.FulfillmentLine: {
        shouldAddFileToEmail ?
          _.set(this.notification, 'orderAttachmentFileTypes', []) :
          _.unset(this.notification, 'orderAttachmentFileTypes');
        break;
      }
    }
  }

  onToggleIgnoreLowQualityAddress() {
    this.notification.ignoreLowQualityAddress = !this.notification.ignoreLowQualityAddress
  }

  onNotificationActivationChange(value) {
    this.notification.active = value;
  }

  onSpecialProgramActivationChange(specialProgramId, value) {
    this.notification.specialProgramMap[specialProgramId].active = value;
  }

  onSpecialOperationalContactActivationChange(operationalContactType: string, value) {
    this.notification.specialOperationalContactsMap[operationalContactType].active = value;
  }

  save(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.onSave({notification: this.notification});
      }
    }
  }

  onScheduleMessageSettingsScheduleTimeChange(dateObj, notification) {
    if (notification.template && notification.template.trigger === TextTriggerType.REMINDER_SMS_DAY_BEFORE_OPERATIONAL_CONTACTS) {
      if (!(dateObj instanceof Date)) {
        notification.template.scheduleMessageSetting.scheduleTime = undefined;
      }
      var hh = dateObj.getHours().toString().padStart(2, '0');
      var mm = dateObj.getMinutes().toString().padStart(2, '0');

      notification.template.scheduleMessageSetting.scheduleTime = hh + ':' + mm;
    } else {
      if (!(dateObj instanceof Date)) {
        notification.scheduleMessageSetting.scheduleTime = undefined;
      }
      var hh = dateObj.getHours().toString().padStart(2, '0');
      var mm = dateObj.getMinutes().toString().padStart(2, '0');

      notification.scheduleMessageSetting.scheduleTime = hh + ':' + mm;
    }
  }

  onScheduleBeforeInMinutesChange(days, notification) {
    if (notification.template && notification.template.trigger === TextTriggerType.REMINDER_SMS_DAY_BEFORE_OPERATIONAL_CONTACTS) {
      notification.template.scheduleMessageSetting.scheduleBeforeInMinutes = !!days ?
          parseInt(days, 10) * 60 * 24 :
          undefined
    } else {
      notification.scheduleMessageSetting.scheduleBeforeInMinutes = !!days ?
          parseInt(days, 10) * 60 * 24 :
          undefined
    }

  }

}

angular
  .module('bringoz.admin.notifications')
  .component('notificationConfigurationForm', {
    bindings: {
      notification: '<',
      selectedNavLanguage: '<',
      cancellationTags: '<',
      fileTypes: '<',
      siteTags: '<',
      sitePrograms: '<',
      onReset: '&',
      onSave: '&'
    },
    template: require('./notification-configuration-form.html').default,
    controller: NotificationConfigurationFormComponent
  });
